import { AIAgent, AgentAvatarSpriteSet, SpriteDirection, SpriteFrameType, SpriteSlotKey } from '../types';

export interface SpriteSlotDefinition {
  key: SpriteSlotKey;
  slotNumber: number;
  direction: SpriteDirection;
  directionLabel: string;
  directionIcon: string;
  gridAxisLabel: string;
  frameType: SpriteFrameType;
  frameLabel: string;
  shortLabel: string;
  description: string;
}

export const SPRITE_16_SLOTS: SpriteSlotDefinition[] = [
  // 1-4: Front-Right / SE (Direction towards +Col)
  {
    key: 'front_idle',
    slotNumber: 1,
    direction: 'front',
    directionLabel: 'Front-Right (SE)',
    directionIcon: '↘️',
    gridAxisLabel: '+Column (Down-Right)',
    frameType: 'idle',
    frameLabel: 'Isometric Idle (3/4)',
    shortLabel: 'SE Idle',
    description: 'Isometric 3/4 view facing down-right in idle pose.',
  },
  {
    key: 'front_walk1',
    slotNumber: 2,
    direction: 'front',
    directionLabel: 'Front-Right (SE)',
    directionIcon: '↘️',
    gridAxisLabel: '+Column (Down-Right)',
    frameType: 'walk1',
    frameLabel: 'Step 1 (Left Leg)',
    shortLabel: 'SE Step 1',
    description: 'Isometric 3/4 view stepping diagonally down-right (left leg forward).',
  },
  {
    key: 'front_walk2',
    slotNumber: 3,
    direction: 'front',
    directionLabel: 'Front-Right (SE)',
    directionIcon: '↘️',
    gridAxisLabel: '+Column (Down-Right)',
    frameType: 'walk2',
    frameLabel: 'Step 2 (Mid Contact)',
    shortLabel: 'SE Step 2',
    description: 'Isometric 3/4 view in mid-step stride transition.',
  },
  {
    key: 'front_walk3',
    slotNumber: 4,
    direction: 'front',
    directionLabel: 'Front-Right (SE)',
    directionIcon: '↘️',
    gridAxisLabel: '+Column (Down-Right)',
    frameType: 'walk3',
    frameLabel: 'Step 3 (Right Leg)',
    shortLabel: 'SE Step 3',
    description: 'Isometric 3/4 view stepping diagonally down-right (right leg forward).',
  },

  // 5-8: Back-Left / NW (Direction towards -Col)
  {
    key: 'back_idle',
    slotNumber: 5,
    direction: 'back',
    directionLabel: 'Back-Left (NW)',
    directionIcon: '↖️',
    gridAxisLabel: '-Column (Up-Left)',
    frameType: 'idle',
    frameLabel: 'Isometric Idle (3/4)',
    shortLabel: 'NW Idle',
    description: 'Back isometric 3/4 view facing up-left.',
  },
  {
    key: 'back_walk1',
    slotNumber: 6,
    direction: 'back',
    directionLabel: 'Back-Left (NW)',
    directionIcon: '↖️',
    gridAxisLabel: '-Column (Up-Left)',
    frameType: 'walk1',
    frameLabel: 'Step 1 (Left Leg)',
    shortLabel: 'NW Step 1',
    description: 'Back view stepping diagonally up-left.',
  },
  {
    key: 'back_walk2',
    slotNumber: 7,
    direction: 'back',
    directionLabel: 'Back-Left (NW)',
    directionIcon: '↖️',
    gridAxisLabel: '-Column (Up-Left)',
    frameType: 'walk2',
    frameLabel: 'Step 2 (Mid Contact)',
    shortLabel: 'NW Step 2',
    description: 'Back view in mid-step transition.',
  },
  {
    key: 'back_walk3',
    slotNumber: 8,
    direction: 'back',
    directionLabel: 'Back-Left (NW)',
    directionIcon: '↖️',
    gridAxisLabel: '-Column (Up-Left)',
    frameType: 'walk3',
    frameLabel: 'Step 3 (Right Leg)',
    shortLabel: 'NW Step 3',
    description: 'Back view stepping diagonally up-left.',
  },

  // 9-12: Front-Left / SW (Direction towards +Row)
  {
    key: 'left_idle',
    slotNumber: 9,
    direction: 'left',
    directionLabel: 'Front-Left (SW)',
    directionIcon: '↙️',
    gridAxisLabel: '+Row (Down-Left)',
    frameType: 'idle',
    frameLabel: 'Isometric Idle (3/4)',
    shortLabel: 'SW Idle',
    description: 'Isometric 3/4 view facing down-left in idle pose.',
  },
  {
    key: 'left_walk1',
    slotNumber: 10,
    direction: 'left',
    directionLabel: 'Front-Left (SW)',
    directionIcon: '↙️',
    gridAxisLabel: '+Row (Down-Left)',
    frameType: 'walk1',
    frameLabel: 'Step 1 (Right Leg)',
    shortLabel: 'SW Step 1',
    description: 'Isometric 3/4 view stepping diagonally down-left.',
  },
  {
    key: 'left_walk2',
    slotNumber: 11,
    direction: 'left',
    directionLabel: 'Front-Left (SW)',
    directionIcon: '↙️',
    gridAxisLabel: '+Row (Down-Left)',
    frameType: 'walk2',
    frameLabel: 'Step 2 (Mid Contact)',
    shortLabel: 'SW Step 2',
    description: 'Isometric 3/4 view in mid-step stride.',
  },
  {
    key: 'left_walk3',
    slotNumber: 12,
    direction: 'left',
    directionLabel: 'Front-Left (SW)',
    directionIcon: '↙️',
    gridAxisLabel: '+Row (Down-Left)',
    frameType: 'walk3',
    frameLabel: 'Step 3 (Left Leg)',
    shortLabel: 'SW Step 3',
    description: 'Isometric 3/4 view stepping diagonally down-left.',
  },

  // 13-16: Back-Right / NE (Direction towards -Row)
  {
    key: 'right_idle',
    slotNumber: 13,
    direction: 'right',
    directionLabel: 'Back-Right (NE)',
    directionIcon: '↗️',
    gridAxisLabel: '-Row (Up-Right)',
    frameType: 'idle',
    frameLabel: 'Isometric Idle (3/4)',
    shortLabel: 'NE Idle',
    description: 'Back isometric 3/4 view facing up-right in idle pose.',
  },
  {
    key: 'right_walk1',
    slotNumber: 14,
    direction: 'right',
    directionLabel: 'Back-Right (NE)',
    directionIcon: '↗️',
    gridAxisLabel: '-Row (Up-Right)',
    frameType: 'walk1',
    frameLabel: 'Step 1 (Right Leg)',
    shortLabel: 'NE Step 1',
    description: 'Back view stepping diagonally up-right.',
  },
  {
    key: 'right_walk2',
    slotNumber: 15,
    direction: 'right',
    directionLabel: 'Back-Right (NE)',
    directionIcon: '↗️',
    gridAxisLabel: '-Row (Up-Right)',
    frameType: 'walk2',
    frameLabel: 'Step 2 (Mid Contact)',
    shortLabel: 'NE Step 2',
    description: 'Back view in mid-step transition.',
  },
  {
    key: 'right_walk3',
    slotNumber: 16,
    direction: 'right',
    directionLabel: 'Back-Right (NE)',
    directionIcon: '↗️',
    gridAxisLabel: '-Row (Up-Right)',
    frameType: 'walk3',
    frameLabel: 'Step 3 (Left Leg)',
    shortLabel: 'NE Step 3',
    description: 'Back view stepping diagonally up-right.',
  },
];

export const DIRECTION_ORDER: {
  id: SpriteDirection;
  label: string;
  isoName: string;
  icon: string;
  gridDescription: string;
}[] = [
  {
    id: 'front',
    label: 'Front-Right (SE)',
    isoName: 'Southeast ↘️',
    icon: '↘️',
    gridDescription: 'Towards +Column (Down-Right)',
  },
  {
    id: 'left',
    label: 'Front-Left (SW)',
    isoName: 'Southwest ↙️',
    icon: '↙️',
    gridDescription: 'Towards +Row (Down-Left)',
  },
  {
    id: 'back',
    label: 'Back-Left (NW)',
    isoName: 'Northwest ↖️',
    icon: '↖️',
    gridDescription: 'Towards -Column (Up-Left)',
  },
  {
    id: 'right',
    label: 'Back-Right (NE)',
    isoName: 'Northeast ↗️',
    icon: '↗️',
    gridDescription: 'Towards -Row (Up-Right)',
  },
];

// Dimensional specification for Agent Avatars in isometric space:
// - 1 isometric cube base = 1 tile (64 × 32 px)
// - 1 isometric cube vertical height = 32 px (TILE_HEIGHT)
// - Agent avatar total height = 2 cubes = 64 px (2 * TILE_HEIGHT)
// - Standard native frame dimensions: 56 × 64 px
export const ISOMETRIC_CUBE_HEIGHT_PX = 32; // Height of 1 cube
export const AGENT_AVATAR_HEIGHT_PX = 64;   // Height of 2 cubes (2 * 32px)
export const AGENT_AVATAR_WIDTH_PX = 56;    // Proportional width for 2-cube avatar

// Default Nogalious Hero Reference Palette
export const NOGALIOUS_PALETTE = {
  shirtColor: '#138996',     // Teal / Aquamarine Tunic
  hairColor: '#854d0e',      // Chestnut Brown Swept Hair
  skinColor: '#ff9f7d',      // Warm Peach Skin
  pantsColor: '#064e3b',     // Dark Hunter Green Pants & Boots
  headbandColor: '#78350f',  // Leather Brown Bandana
  buckleColor: '#facc15',    // Gold Belt Buckle
  eyeColor: '#1d4ed8',       // Vivid Sapphire Blue Eyes
  cheekColor: '#ff627d',     // Pink Cheek Blush
  outlineColor: '#090d16',   // Crisp Dark Outline
};

/**
 * Generates true 3/4 Isometric Perspective pixel-art character frames
 * based on the Nogalious hero reference:
 * - Swept chestnut brown hair with top-right crest and headband ribbon tails
 * - Big expressive blue eyes with white glint and pink cheek blush
 * - Teal / aquamarine doublet tunic with diagonal brown leather shoulder strap
 * - Brown belt with bright gold buckle
 * - Hunter green trousers and boots
 */
export function generateProceduralSpriteFrame(
  direction: SpriteDirection,
  frameType: SpriteFrameType,
  shirtColor: string = NOGALIOUS_PALETTE.shirtColor,
  hairColor: string = NOGALIOUS_PALETTE.hairColor,
  skinColor: string = NOGALIOUS_PALETTE.skinColor,
  pantsColor: string = NOGALIOUS_PALETTE.pantsColor
): string {
  if (typeof document === 'undefined') return '';
  const canvas = document.createElement('canvas');
  canvas.width = 36;
  canvas.height = 40;
  const ctx = canvas.getContext('2d');
  if (!ctx) return '';

  ctx.imageSmoothingEnabled = false;

  const isWalk1 = frameType === 'walk1';
  const isWalk2 = frameType === 'walk2';
  const isWalk3 = frameType === 'walk3';

  // Walk vertical bobbing
  const bobY = isWalk1 || isWalk3 ? 1 : 0;

  // Shading & Highlight palettes derived from base colors
  const shadowShirt = adjustColorBrightness(shirtColor, -24);
  const highlightShirt = adjustColorBrightness(shirtColor, 22);
  const shadowSkin = adjustColorBrightness(skinColor, -18);
  const shadowPants = adjustColorBrightness(pantsColor, -25);
  const highlightHair = adjustColorBrightness(hairColor, 22);
  const shadowHair = adjustColorBrightness(hairColor, -30);
  const darkOutline = '#090d16';
  const goldBuckle = NOGALIOUS_PALETTE.buckleColor;
  const strapColor = '#78350f';
  const eyeBlue = NOGALIOUS_PALETTE.eyeColor;
  const blushPink = NOGALIOUS_PALETTE.cheekColor;

  // =========================================================================
  // 1. DIRECTION: FRONT-RIGHT (SE / ↘️) — Facing Camera Down-Right (+Col)
  // =========================================================================
  if (direction === 'front') {
    // --- Headband Ribbon Tails (Hanging on left side/back) ---
    ctx.fillStyle = hairColor;
    ctx.fillRect(7, 15 + bobY, 4, 3);
    ctx.fillRect(8, 18 + bobY, 3, 4);
    ctx.fillStyle = darkOutline;
    ctx.strokeRect(6.5, 14.5 + bobY, 5, 8);

    // --- Hair Volume & Top Crest ---
    ctx.fillStyle = hairColor;
    ctx.fillRect(10, 3 + bobY, 15, 8);
    // Crest swooping up on top right
    ctx.fillRect(19, 1 + bobY, 8, 4);
    ctx.fillRect(23, 0 + bobY, 5, 3);
    // Highlights & Shadows on hair
    ctx.fillStyle = highlightHair;
    ctx.fillRect(14, 3 + bobY, 7, 2);
    ctx.fillRect(20, 2 + bobY, 5, 2);
    ctx.fillStyle = shadowHair;
    ctx.fillRect(10, 7 + bobY, 4, 4);
    ctx.fillRect(22, 6 + bobY, 4, 5);

    // --- Face Base (3/4 Angle) ---
    ctx.fillStyle = skinColor;
    ctx.fillRect(12, 8 + bobY, 12, 8);
    ctx.fillStyle = shadowSkin;
    ctx.fillRect(21, 9 + bobY, 3, 7); // cheek depth shadow

    // --- Headband Brow Line ---
    ctx.fillStyle = strapColor;
    ctx.fillRect(11, 7 + bobY, 13, 2);

    // --- Eyes (Distinctive Nogalious Blue Eyes with Sclera & Dark Lash) ---
    // Dark Brow / Eyelash outline
    ctx.fillStyle = darkOutline;
    ctx.fillRect(13, 9 + bobY, 4, 1);
    ctx.fillRect(19, 9 + bobY, 4, 1);

    // Sclera / White
    ctx.fillStyle = '#ffffff';
    ctx.fillRect(13, 10 + bobY, 4, 3);
    ctx.fillRect(19, 10 + bobY, 4, 3);

    // Blue Iris
    ctx.fillStyle = eyeBlue;
    ctx.fillRect(15, 10 + bobY, 2, 3);
    ctx.fillRect(21, 10 + bobY, 2, 3);

    // Eye highlights
    ctx.fillStyle = '#93c5fd';
    ctx.fillRect(15, 10 + bobY, 1, 1);
    ctx.fillRect(21, 10 + bobY, 1, 1);

    // --- Rosy Cheek Blush ---
    ctx.fillStyle = blushPink;
    ctx.fillRect(12, 13 + bobY, 3, 2);
    ctx.fillRect(20, 13 + bobY, 3, 2);

    // --- Black Neck Choker/Collar ---
    ctx.fillStyle = darkOutline;
    ctx.fillRect(12, 16 + bobY, 10, 2);

    // --- Torso / Doublet Tunic (Teal with Diagonal Strap & Belt) ---
    ctx.fillStyle = highlightShirt;
    ctx.fillRect(9, 18 + bobY, 6, 8); // illuminated left chest
    ctx.fillStyle = shirtColor;
    ctx.fillRect(15, 18 + bobY, 8, 8);
    ctx.fillStyle = shadowShirt;
    ctx.fillRect(22, 19 + bobY, 3, 7);

    // Diagonal Leather Shoulder Strap (Nogalious Baldric)
    ctx.fillStyle = strapColor;
    ctx.fillRect(13, 18 + bobY, 3, 3);
    ctx.fillRect(16, 21 + bobY, 3, 3);
    ctx.fillRect(19, 23 + bobY, 3, 3);

    // Leather Belt & Bright Gold Buckle
    ctx.fillStyle = strapColor;
    ctx.fillRect(9, 25 + bobY, 15, 3);
    ctx.fillStyle = goldBuckle;
    ctx.fillRect(14, 25 + bobY, 5, 3); // Radiant gold buckle
    ctx.fillStyle = '#ffffff';
    ctx.fillRect(15, 25 + bobY, 2, 1); // gold sheen

    // --- Arms & Hands ---
    ctx.fillStyle = shirtColor;
    if (isWalk1) {
      // Left arm back, Right arm forward
      ctx.fillRect(7, 18 + bobY, 3, 5);
      ctx.fillStyle = skinColor;
      ctx.fillRect(7, 23 + bobY, 3, 3); // left hand

      ctx.fillStyle = shadowShirt;
      ctx.fillRect(23, 20 + bobY, 4, 5);
      ctx.fillStyle = shadowSkin;
      ctx.fillRect(24, 25 + bobY, 3, 3); // right hand forward
    } else if (isWalk3) {
      // Left arm forward, Right arm back
      ctx.fillRect(9, 21 + bobY, 3, 5);
      ctx.fillStyle = skinColor;
      ctx.fillRect(9, 26 + bobY, 3, 3);

      ctx.fillStyle = shadowShirt;
      ctx.fillRect(22, 18 + bobY, 3, 5);
      ctx.fillStyle = shadowSkin;
      ctx.fillRect(23, 22 + bobY, 3, 3);
    } else {
      // Idle / Walk2
      ctx.fillRect(7, 19 + bobY, 3, 5);
      ctx.fillStyle = skinColor;
      ctx.fillRect(7, 24 + bobY, 3, 3);

      ctx.fillStyle = shadowShirt;
      ctx.fillRect(23, 20 + bobY, 3, 5);
      ctx.fillStyle = shadowSkin;
      ctx.fillRect(23, 25 + bobY, 3, 3);
    }

    // --- Legs & Hunter Green Boots ---
    ctx.fillStyle = pantsColor;
    if (isWalk1) {
      // Left leg back
      ctx.fillRect(10, 28 + bobY, 5, 6);
      ctx.fillStyle = shadowPants;
      // Right leg stepping forward SE
      ctx.fillRect(18, 28 + bobY, 6, 8);
    } else if (isWalk3) {
      // Left leg stepping forward SE
      ctx.fillRect(12, 28 + bobY, 6, 8);
      ctx.fillStyle = shadowPants;
      // Right leg back
      ctx.fillRect(19, 28 + bobY, 5, 5);
    } else {
      ctx.fillRect(11, 28 + bobY, 5, 7);
      ctx.fillStyle = shadowPants;
      ctx.fillRect(18, 28 + bobY, 5, 7);
    }

    // Hunter Green Boots with Cuffs
    ctx.fillStyle = shadowPants;
    if (isWalk1) {
      ctx.fillRect(9, 34, 6, 4);
      ctx.fillRect(18, 35, 7, 4);
    } else if (isWalk3) {
      ctx.fillRect(12, 35, 7, 4);
      ctx.fillRect(19, 33, 5, 4);
    } else {
      ctx.fillRect(10, 34, 6, 4);
      ctx.fillRect(18, 34, 6, 4);
    }
  }

  // =========================================================================
  // 2. DIRECTION: FRONT-LEFT (SW / ↙️) — Facing Camera Down-Left (+Row)
  // =========================================================================
  else if (direction === 'left') {
    // --- Hair Volume (Angled SW) ---
    ctx.fillStyle = hairColor;
    ctx.fillRect(10, 3 + bobY, 15, 8);
    // Crest swooping on top left
    ctx.fillRect(8, 1 + bobY, 8, 4);
    ctx.fillRect(7, 0 + bobY, 5, 3);
    // Highlights & Shadows
    ctx.fillStyle = highlightHair;
    ctx.fillRect(14, 3 + bobY, 7, 2);
    ctx.fillRect(9, 2 + bobY, 5, 2);
    ctx.fillStyle = shadowHair;
    ctx.fillRect(21, 7 + bobY, 4, 4);

    // --- Face Base (3/4 SW Angle) ---
    ctx.fillStyle = skinColor;
    ctx.fillRect(11, 8 + bobY, 12, 8);
    ctx.fillStyle = shadowSkin;
    ctx.fillRect(11, 9 + bobY, 3, 7); // left cheek shadow

    // --- Headband Brow Line ---
    ctx.fillStyle = strapColor;
    ctx.fillRect(11, 7 + bobY, 13, 2);

    // --- Eyes (Blue + Sclera + Dark Lash) ---
    ctx.fillStyle = darkOutline;
    ctx.fillRect(12, 9 + bobY, 4, 1);
    ctx.fillRect(18, 9 + bobY, 4, 1);

    ctx.fillStyle = '#ffffff';
    ctx.fillRect(12, 10 + bobY, 4, 3);
    ctx.fillRect(18, 10 + bobY, 4, 3);

    ctx.fillStyle = eyeBlue;
    ctx.fillRect(13, 10 + bobY, 2, 3);
    ctx.fillRect(19, 10 + bobY, 2, 3);

    ctx.fillStyle = '#93c5fd';
    ctx.fillRect(13, 10 + bobY, 1, 1);
    ctx.fillRect(19, 10 + bobY, 1, 1);

    // --- Rosy Cheek Blush ---
    ctx.fillStyle = blushPink;
    ctx.fillRect(12, 13 + bobY, 3, 2);
    ctx.fillRect(20, 13 + bobY, 3, 2);

    // --- Black Neck Choker/Collar ---
    ctx.fillStyle = darkOutline;
    ctx.fillRect(13, 16 + bobY, 10, 2);

    // --- Torso / Doublet Tunic ---
    ctx.fillStyle = shadowShirt;
    ctx.fillRect(10, 19 + bobY, 4, 7);
    ctx.fillStyle = shirtColor;
    ctx.fillRect(12, 18 + bobY, 8, 8);
    ctx.fillStyle = highlightShirt;
    ctx.fillRect(19, 18 + bobY, 6, 8);

    // Diagonal Strap (Mirrored for SW)
    ctx.fillStyle = strapColor;
    ctx.fillRect(19, 18 + bobY, 3, 3);
    ctx.fillRect(16, 21 + bobY, 3, 3);
    ctx.fillRect(13, 23 + bobY, 3, 3);

    // Belt & Buckle
    ctx.fillStyle = strapColor;
    ctx.fillRect(11, 25 + bobY, 15, 3);
    ctx.fillStyle = goldBuckle;
    ctx.fillRect(16, 25 + bobY, 5, 3);
    ctx.fillStyle = '#ffffff';
    ctx.fillRect(17, 25 + bobY, 2, 1);

    // --- Arms & Hands ---
    if (isWalk1) {
      ctx.fillStyle = shadowShirt;
      ctx.fillRect(9, 20 + bobY, 3, 5);
      ctx.fillStyle = shadowSkin;
      ctx.fillRect(8, 25 + bobY, 3, 3); // left hand forward in SW

      ctx.fillStyle = shirtColor;
      ctx.fillRect(24, 18 + bobY, 3, 5);
      ctx.fillStyle = skinColor;
      ctx.fillRect(24, 23 + bobY, 3, 3);
    } else if (isWalk3) {
      ctx.fillStyle = shadowShirt;
      ctx.fillRect(10, 18 + bobY, 3, 5);
      ctx.fillStyle = shadowSkin;
      ctx.fillRect(9, 22 + bobY, 3, 3);

      ctx.fillStyle = shirtColor;
      ctx.fillRect(22, 21 + bobY, 3, 5);
      ctx.fillStyle = skinColor;
      ctx.fillRect(22, 26 + bobY, 3, 3);
    } else {
      ctx.fillStyle = shadowShirt;
      ctx.fillRect(9, 20 + bobY, 3, 5);
      ctx.fillStyle = shadowSkin;
      ctx.fillRect(9, 25 + bobY, 3, 3);

      ctx.fillStyle = shirtColor;
      ctx.fillRect(24, 19 + bobY, 3, 5);
      ctx.fillStyle = skinColor;
      ctx.fillRect(24, 24 + bobY, 3, 3);
    }

    // --- Legs & Hunter Green Boots ---
    ctx.fillStyle = pantsColor;
    if (isWalk1) {
      ctx.fillStyle = shadowPants;
      ctx.fillRect(11, 28 + bobY, 6, 8); // left leg forward in SW
      ctx.fillStyle = pantsColor;
      ctx.fillRect(19, 28 + bobY, 5, 5);
    } else if (isWalk3) {
      ctx.fillStyle = shadowPants;
      ctx.fillRect(11, 28 + bobY, 5, 6);
      ctx.fillStyle = pantsColor;
      ctx.fillRect(17, 28 + bobY, 6, 8); // right leg forward in SW
    } else {
      ctx.fillStyle = shadowPants;
      ctx.fillRect(12, 28 + bobY, 5, 7);
      ctx.fillStyle = pantsColor;
      ctx.fillRect(18, 28 + bobY, 5, 7);
    }

    // Boots SW
    ctx.fillStyle = shadowPants;
    if (isWalk1) {
      ctx.fillRect(10, 35, 7, 4);
      ctx.fillRect(19, 33, 5, 4);
    } else if (isWalk3) {
      ctx.fillRect(10, 33, 5, 4);
      ctx.fillRect(17, 35, 7, 4);
    } else {
      ctx.fillRect(11, 34, 6, 4);
      ctx.fillRect(18, 34, 6, 4);
    }
  }

  // =========================================================================
  // 3. DIRECTION: BACK-LEFT (NW / ↖️) — Facing Away Up-Left (-Col)
  // =========================================================================
  else if (direction === 'back') {
    // --- Headband Ribbon Knot & Tails (Visible on Back-Left) ---
    ctx.fillStyle = hairColor;
    ctx.fillRect(6, 14 + bobY, 4, 3);
    ctx.fillRect(7, 17 + bobY, 3, 5);
    ctx.fillStyle = darkOutline;
    ctx.strokeRect(5.5, 13.5 + bobY, 5, 9);

    // Full Back Hair Volume
    ctx.fillStyle = hairColor;
    ctx.fillRect(10, 3 + bobY, 15, 11);
    ctx.fillRect(18, 1 + bobY, 8, 4); // Crest from behind
    ctx.fillStyle = highlightHair;
    ctx.fillRect(14, 4 + bobY, 8, 2);
    ctx.fillStyle = shadowHair;
    ctx.fillRect(8, 7 + bobY, 4, 7);

    // Headband wrapped around back of head
    ctx.fillStyle = strapColor;
    ctx.fillRect(9, 10 + bobY, 16, 2);

    // Back Neck & Dark Collar
    ctx.fillStyle = skinColor;
    ctx.fillRect(14, 14 + bobY, 7, 3);
    ctx.fillStyle = darkOutline;
    ctx.fillRect(13, 16 + bobY, 9, 2);

    // Back of Doublet Tunic
    ctx.fillStyle = shadowShirt;
    ctx.fillRect(9, 18 + bobY, 5, 9);
    ctx.fillStyle = shirtColor;
    ctx.fillRect(13, 18 + bobY, 12, 9);

    // Strap across back
    ctx.fillStyle = strapColor;
    ctx.fillRect(19, 18 + bobY, 3, 3);
    ctx.fillRect(16, 21 + bobY, 3, 3);
    ctx.fillRect(13, 24 + bobY, 3, 3);

    // Back of Belt
    ctx.fillStyle = strapColor;
    ctx.fillRect(10, 26 + bobY, 15, 3);

    // Back Arms
    if (isWalk1) {
      ctx.fillStyle = shadowShirt;
      ctx.fillRect(7, 20 + bobY, 3, 5);
      ctx.fillStyle = shirtColor;
      ctx.fillRect(24, 18 + bobY, 3, 5);
    } else if (isWalk3) {
      ctx.fillStyle = shadowShirt;
      ctx.fillRect(8, 18 + bobY, 3, 5);
      ctx.fillStyle = shirtColor;
      ctx.fillRect(23, 21 + bobY, 3, 5);
    } else {
      ctx.fillStyle = shadowShirt;
      ctx.fillRect(7, 19 + bobY, 3, 5);
      ctx.fillStyle = shirtColor;
      ctx.fillRect(24, 19 + bobY, 3, 5);
    }

    // Back Legs & Boots
    ctx.fillStyle = pantsColor;
    if (isWalk1) {
      ctx.fillStyle = shadowPants;
      ctx.fillRect(11, 28 + bobY, 5, 6);
      ctx.fillStyle = pantsColor;
      ctx.fillRect(18, 28 + bobY, 6, 8); // right leg walking away NW
    } else if (isWalk3) {
      ctx.fillStyle = shadowPants;
      ctx.fillRect(11, 28 + bobY, 6, 8); // left leg walking away NW
      ctx.fillStyle = pantsColor;
      ctx.fillRect(18, 28 + bobY, 5, 6);
    } else {
      ctx.fillRect(12, 28 + bobY, 5, 7);
      ctx.fillRect(18, 28 + bobY, 5, 7);
    }

    // Boots back
    ctx.fillStyle = shadowPants;
    ctx.fillRect(11, 34, 5, 4);
    ctx.fillRect(18, 34, 5, 4);
  }

  // =========================================================================
  // 4. DIRECTION: BACK-RIGHT (NE / ↗️) — Facing Away Up-Right (-Row)
  // =========================================================================
  else if (direction === 'right') {
    // Full Back Hair Volume
    ctx.fillStyle = hairColor;
    ctx.fillRect(9, 3 + bobY, 16, 11);
    ctx.fillRect(8, 1 + bobY, 8, 4); // Crest top left from behind
    ctx.fillStyle = highlightHair;
    ctx.fillRect(12, 4 + bobY, 8, 2);
    ctx.fillStyle = shadowHair;
    ctx.fillRect(21, 7 + bobY, 4, 7);

    // Headband wrapped around back of head
    ctx.fillStyle = strapColor;
    ctx.fillRect(10, 10 + bobY, 16, 2);

    // Back Neck & Dark Collar
    ctx.fillStyle = skinColor;
    ctx.fillRect(14, 14 + bobY, 7, 3);
    ctx.fillStyle = darkOutline;
    ctx.fillRect(13, 16 + bobY, 9, 2);

    // Back of Doublet Tunic
    ctx.fillStyle = shirtColor;
    ctx.fillRect(10, 18 + bobY, 12, 9);
    ctx.fillStyle = shadowShirt;
    ctx.fillRect(21, 18 + bobY, 5, 9);

    // Strap across back
    ctx.fillStyle = strapColor;
    ctx.fillRect(12, 18 + bobY, 3, 3);
    ctx.fillRect(15, 21 + bobY, 3, 3);
    ctx.fillRect(18, 24 + bobY, 3, 3);

    // Back of Belt
    ctx.fillStyle = strapColor;
    ctx.fillRect(10, 26 + bobY, 15, 3);

    // Back Arms
    if (isWalk1) {
      ctx.fillStyle = shirtColor;
      ctx.fillRect(8, 18 + bobY, 3, 5);
      ctx.fillStyle = shadowShirt;
      ctx.fillRect(24, 21 + bobY, 3, 5);
    } else if (isWalk3) {
      ctx.fillStyle = shirtColor;
      ctx.fillRect(9, 21 + bobY, 3, 5);
      ctx.fillStyle = shadowShirt;
      ctx.fillRect(23, 18 + bobY, 3, 5);
    } else {
      ctx.fillStyle = shirtColor;
      ctx.fillRect(8, 19 + bobY, 3, 5);
      ctx.fillStyle = shadowShirt;
      ctx.fillRect(24, 19 + bobY, 3, 5);
    }

    // Back Legs & Boots
    ctx.fillStyle = pantsColor;
    if (isWalk1) {
      ctx.fillRect(11, 28 + bobY, 6, 8);
      ctx.fillStyle = shadowPants;
      ctx.fillRect(19, 28 + bobY, 5, 6);
    } else if (isWalk3) {
      ctx.fillRect(12, 28 + bobY, 5, 6);
      ctx.fillStyle = shadowPants;
      ctx.fillRect(18, 28 + bobY, 6, 8);
    } else {
      ctx.fillRect(12, 28 + bobY, 5, 7);
      ctx.fillStyle = shadowPants;
      ctx.fillRect(18, 28 + bobY, 5, 7);
    }

    // Boots back
    ctx.fillStyle = shadowPants;
    ctx.fillRect(12, 34, 5, 4);
    ctx.fillRect(18, 34, 5, 4);
  }

  // Scale up onto a native 56 × 64 px canvas (exactly 2 isometric cubes high)
  const outCanvas = document.createElement('canvas');
  outCanvas.width = AGENT_AVATAR_WIDTH_PX; // 56
  outCanvas.height = AGENT_AVATAR_HEIGHT_PX; // 64 (2 cubes high)
  const outCtx = outCanvas.getContext('2d');
  if (!outCtx) return canvas.toDataURL('image/png');

  outCtx.imageSmoothingEnabled = false;
  outCtx.drawImage(canvas, 0, 0, AGENT_AVATAR_WIDTH_PX, AGENT_AVATAR_HEIGHT_PX);

  return outCanvas.toDataURL('image/png');
}

/**
 * Adjust hex color brightness for lighting and shading
 */
function adjustColorBrightness(hex: string, percent: number): string {
  const num = parseInt(hex.replace('#', ''), 16);
  const amt = Math.round(2.55 * percent);
  const R = Math.max(0, Math.min(255, (num >> 16) + amt));
  const G = Math.max(0, Math.min(255, ((num >> 8) & 0x00ff) + amt));
  const B = Math.max(0, Math.min(255, (num & 0x0000ff) + amt));
  return `#${(0x1000000 + R * 0x10000 + G * 0x100 + B).toString(16).slice(1)}`;
}

/**
 * Generates a full 16-frame dictionary for an agent
 */
export function generateFull16SpriteSet(
  shirtColor: string = NOGALIOUS_PALETTE.shirtColor,
  hairColor: string = NOGALIOUS_PALETTE.hairColor,
  skinColor: string = NOGALIOUS_PALETTE.skinColor,
  pantsColor: string = NOGALIOUS_PALETTE.pantsColor
): AgentAvatarSpriteSet {
  const result: Partial<AgentAvatarSpriteSet> = {};

  SPRITE_16_SLOTS.forEach((slot) => {
    result[slot.key] = generateProceduralSpriteFrame(
      slot.direction,
      slot.frameType,
      shirtColor,
      hairColor,
      skinColor,
      pantsColor
    );
  });

  return result as AgentAvatarSpriteSet;
}

export interface SpritePreset {
  id: string;
  name: string;
  role: string;
  description: string;
  icon: string;
  shirtColor: string;
  hairColor: string;
  pantsColor: string;
}

export const SPRITE_PRESETS: SpritePreset[] = [
  {
    id: 'nogalious_hero',
    name: 'Nogalious (Original Hero)',
    role: 'hero',
    description: 'Classic pixel-art style with windblown brown hair, headband, blue eyes, teal tunic, and green boots.',
    icon: '🗡️',
    shirtColor: '#138996',
    hairColor: '#854d0e',
    pantsColor: '#064e3b',
  },
  {
    id: 'cyber_devops',
    name: 'DevOps / SysAdmin',
    role: 'devops',
    description: 'Technical variant in cobalt blue with dark hair and charcoal boots.',
    icon: '⚡',
    shirtColor: '#0284c7',
    hairColor: '#0f172a',
    pantsColor: '#1e293b',
  },
  {
    id: 'frontend_ui',
    name: 'Frontend / UI Designer',
    role: 'frontend',
    description: 'Indigo and purple variant with stylized shading and highlights.',
    icon: '🎨',
    shirtColor: '#6366f1',
    hairColor: '#475569',
    pantsColor: '#0f172a',
  },
  {
    id: 'backend_architect',
    name: 'Backend / Architect',
    role: 'backend',
    description: 'Emerald green variant with diagonal stance and stride.',
    icon: '⚙️',
    shirtColor: '#059669',
    hairColor: '#334155',
    pantsColor: '#1e293b',
  },
  {
    id: 'product_manager',
    name: 'Product Lead / Executive',
    role: 'executive',
    description: 'Warm amber executive suit oriented to all 4 diagonal perspectives.',
    icon: '👔',
    shirtColor: '#d97706',
    hairColor: '#1e293b',
    pantsColor: '#0f172a',
  },
];

/**
 * Image Cache for fast canvas blitting
 */
const spriteImageCache: Map<string, HTMLImageElement> = new Map();

export function getOrLoadSpriteImage(src: string): HTMLImageElement | null {
  if (!src) return null;
  const existing = spriteImageCache.get(src);
  if (existing) return existing;

  const img = new Image();
  img.crossOrigin = 'anonymous';
  img.src = src;
  spriteImageCache.set(src, img);
  return img;
}

/**
 * Returns matching sprite key for an agent's current movement and state
 */
export function getFrameKey(
  direction: SpriteDirection,
  isWalking: boolean,
  walkIndex: number
): SpriteSlotKey {
  if (!isWalking) {
    return `${direction}_idle` as SpriteSlotKey;
  }
  const frameType: SpriteFrameType = walkIndex === 1 ? 'walk1' : walkIndex === 2 ? 'walk2' : 'walk3';
  return `${direction}_${frameType}` as SpriteSlotKey;
}

/**
 * Accurately determines the isometric 4-way direction based on movement vector (dx, dy)
 * on the 2:1 isometric diamond grid.
 *
 * Grid Axis & Isometric Screen Mapping:
 * - dx > 0 (+Col): Moves Down-Right on screen -> 'front' (Frente-Derecha / SE ↘️)
 * - dy > 0 (+Row): Moves Down-Left on screen  -> 'left'  (Frente-Izquierda / SW ↙️)
 * - dx < 0 (-Col): Moves Up-Left on screen    -> 'back'  (Espalda-Izquierda / NW ↖️)
 * - dy < 0 (-Row): Moves Up-Right on screen   -> 'right' (Espalda-Derecha / NE ↗️)
 */
export function getIsometric4Direction(
  dx: number,
  dy: number,
  currentFacing: SpriteDirection = 'front'
): SpriteDirection {
  if (Math.abs(dx) < 0.05 && Math.abs(dy) < 0.05) {
    return currentFacing;
  }

  const absDx = Math.abs(dx);
  const absDy = Math.abs(dy);

  // Dominant column axis movement
  if (absDx >= absDy) {
    if (dx > 0) return 'front'; // +Col -> Sureste (SE ↘️)
    return 'back';             // -Col -> Noroeste (NW ↖️)
  }

  // Dominant row axis movement
  if (dy > 0) return 'left';   // +Row -> Suroeste (SW ↙️)
  return 'right';              // -Row -> Noreste (NE ↗️)
}
